module.exports = __webpack_public_path__ + "b68a6c0982266d6dcca4f9f1046a5943.svg";